import React, { useState, useEffect, useCallback } from 'react';
import Layout from './Layout';

/* ─── Module-level language helper ──────────────────────────────── */
// Reads from localStorage so it works in ALL components in this file
const t = (key, lang = 'ar') => T[key]?.[lang] || T[key]?.en || key;

/* ─── Translations ───────────────────────────────────────────────── */
const T = {
  pageTitle:           { ar: '🏢 المنظمات',             en: '🏢 Organizations' },
  newOrg:              { ar: '+ منظمة جديدة',            en: '+ New Organization' },
  colId:               { ar: 'ID',                        en: 'ID' },
  colName:             { ar: 'الاسم',                     en: 'Name' },
  colSlug:             { ar: 'Slug',                      en: 'Slug' },
  colPlan:             { ar: 'الخطة',                     en: 'Plan' },
  colStatus:           { ar: 'الحالة',                    en: 'Status' },
  colAgents:           { ar: 'الموظفون',                  en: 'Agents' },
  colKB:               { ar: 'KB',                        en: 'KB' },
  colConvos:           { ar: 'المحادثات',                 en: 'Convos' },
  colActions:          { ar: 'الإجراءات',                 en: 'Actions' },
  edit:                { ar: '✏️ تعديل',                  en: '✏️ Edit' },
  deletebtn:           { ar: '🗑️ حذف',                    en: '🗑️ Delete' },
  reactivate:          { ar: '♻️ إعادة تفعيل',            en: '♻️ Reactivate' },
  save:                { ar: '💾 حفظ',                    en: '💾 Save' },
  saving:              { ar: 'جاري الحفظ…',               en: 'Saving…' },
  saveBotSettings:     { ar: '💾 حفظ إعدادات البوت',      en: '💾 Save Bot Settings' },
  cancel:              { ar: '❌ إلغاء',                   en: '❌ Cancel' },
  loading:             { ar: 'جاري التحميل…',             en: 'Loading…' },
  addOffer:            { ar: '+ إضافة عرض',               en: '+ Add Offer' },
  addModule:           { ar: '+ موديول',                  en: '+ Module' },
  resetDefault:        { ar: '↺ إعادة تعيين',             en: '↺ Reset to Default' },
  tabOrg:              { ar: '🏢 المنظمة',                en: '🏢 Organization' },
  tabBot:              { ar: '🤖 إعدادات البوت',           en: '🤖 Bot Settings' },
  tabIdentity:         { ar: '🏷 الهوية',                 en: '🏷 Identity' },
  tabGreeting:         { ar: '👋 الترحيب',                en: '👋 Greeting' },
  tabSales:            { ar: '💼 المبيعات',               en: '💼 Sales' },
  tabPricing:          { ar: '💰 الأسعار',                en: '💰 Pricing' },
  tabIntent:           { ar: '🎯 النية',                  en: '🎯 Intent' },
  tabAdvanced:         { ar: '⚙️ متقدم',                  en: '⚙️ Advanced' },
  createOrgTitle:      { ar: '➕ إنشاء منظمة جديدة',      en: '➕ Create New Organization' },
  fieldOrgName:        { ar: 'اسم المنظمة *',             en: 'Organization Name *' },
  fieldSlug:           { ar: 'كود الدخول (Slug) *',       en: 'Slug (login code) *' },
  fieldOwnerName:      { ar: 'اسم المالك *',              en: 'Owner Name *' },
  fieldOwnerEmail:     { ar: 'إيميل المالك *',            en: 'Owner Email *' },
  fieldOwnerPassword:  { ar: 'كلمة مرور المالك *',        en: 'Owner Password *' },
  fieldWhatsappId:     { ar: 'WhatsApp Phone ID',          en: 'WhatsApp Phone ID' },
  fieldWhatsappToken:  { ar: 'WhatsApp Token',             en: 'WhatsApp Token' },
  fieldPlan:           { ar: 'الخطة',                     en: 'Plan' },
  fieldBotLang:        { ar: 'لغة البوت',                 en: 'Bot Language' },
  fieldTimezone:       { ar: 'المنطقة الزمنية',           en: 'Timezone' },
  fieldTrialDays:      { ar: 'أيام التجربة',              en: 'Trial Days' },
  fieldAiModel:        { ar: 'نموذج الذكاء الاصطناعي',   en: 'AI Model' },
  fieldMonthlyLimit:   { ar: 'حد الرسائل الشهري',         en: 'Monthly Msg Limit' },
  fieldMaxAgents:      { ar: 'أقصى عدد للوكلاء',          en: 'Max Agents' },
  fieldMaxKB:          { ar: 'أقصى عدد لأسئلة KB',        en: 'Max KB Questions' },
  fieldStatus:         { ar: 'الحالة',                    en: 'Status' },
  optional:            { ar: 'اختياري',                   en: 'Optional' },
  planFree:            { ar: 'مجاني',                     en: 'Free' },
  planStarter:         { ar: 'ستارتر',                    en: 'Starter ($49/mo)' },
  planPro:             { ar: 'برو ($149/mo)',              en: 'Pro ($149/mo)' },
  planEnterprise:      { ar: 'إنتربرايز',                 en: 'Enterprise' },
  statusActive:        { ar: 'نشط',                       en: 'Active' },
  statusTrial:         { ar: 'تجريبي',                    en: 'Trial' },
  statusSuspended:     { ar: 'موقوف',                     en: 'Suspended' },
  statusCancelled:     { ar: 'ملغي',                      en: 'Cancelled' },
  langAr:              { ar: 'عربي',                      en: 'Arabic' },
  langEn:              { ar: 'إنجليزي',                   en: 'English' },
  langAuto:            { ar: 'كشف تلقائي',                en: 'Auto-detect' },
  botNameAr:           { ar: 'اسم البوت (عربي)',          en: 'Bot Name (AR)' },
  botNameEn:           { ar: 'اسم البوت (إنجليزي)',       en: 'Bot Name (EN)' },
  companyNameAr:       { ar: 'اسم الشركة (عربي)',         en: 'Company Name (AR)' },
  companyNameEn:       { ar: 'اسم الشركة (إنجليزي)',      en: 'Company Name (EN)' },
  systemNameAr:        { ar: 'اسم النظام (عربي)',          en: 'System Name (AR)' },
  systemNameEn:        { ar: 'اسم النظام (إنجليزي)',       en: 'System Name (EN)' },
  defaultLang:         { ar: 'اللغة الافتراضية',          en: 'Default Language' },
  enableDialect:       { ar: 'تفعيل تبديل اللهجة',        en: 'Enable Dialect Switching' },
  enableLead:          { ar: 'تفعيل استخراج العملاء',     en: 'Enable Lead Extraction' },
  enableBooking:       { ar: 'تفعيل نظام الحجز',          en: 'Enable Booking Module' },
  hasSalesBot:         { ar: 'بوت المبيعات',              en: 'Has Sales Bot' },
  greetingAr:          { ar: 'رسالة الترحيب (عربي)',      en: 'Greeting Message (AR)' },
  greetingEn:          { ar: 'رسالة الترحيب (إنجليزي)',   en: 'Greeting Message (EN)' },
  btnExistingAr:       { ar: 'زر العميل الحالي (عربي)',   en: 'Btn Existing Customer (AR)' },
  btnExistingEn:       { ar: 'زر العميل الحالي (إنجليزي)',en: 'Btn Existing Customer (EN)' },
  btnNewAr:            { ar: 'زر العميل الجديد (عربي)',   en: 'Btn New Customer (AR)' },
  btnNewEn:            { ar: 'زر العميل الجديد (إنجليزي)',en: 'Btn New Customer (EN)' },
  postExistingAr:      { ar: 'رسالة ما بعد الترحيب — حالي (عربي)',    en: 'Post Existing Greeting (AR)' },
  postExistingEn:      { ar: 'رسالة ما بعد الترحيب — حالي (إنجليزي)', en: 'Post Existing Greeting (EN)' },
  postNewAr:           { ar: 'رسالة ما بعد الترحيب — جديد (عربي)',    en: 'Post New Greeting (AR)' },
  postNewEn:           { ar: 'رسالة ما بعد الترحيب — جديد (إنجليزي)', en: 'Post New Greeting (EN)' },
  salesPersonaAr:      { ar: 'شخصية البوت في المبيعات (عربي)',    en: 'Sales Persona (AR)' },
  salesPersonaEn:      { ar: 'شخصية البوت في المبيعات (إنجليزي)', en: 'Sales Persona (EN)' },
  generalInfoAr:       { ar: 'معلومات عامة (عربي)',               en: 'General Info (AR)' },
  generalInfoEn:       { ar: 'معلومات عامة (إنجليزي)',            en: 'General Info (EN)' },
  successStories:      { ar: 'قصص النجاح',                        en: 'Success Stories' },
  specialOffers:       { ar: 'العروض الخاصة',                     en: 'Special Offers' },
  offerTextArPh:       { ar: 'نص العرض بالعربي...',               en: 'Offer text in Arabic...' },
  offerTextEnPh:       { ar: 'نص العرض بالإنجليزي...',            en: 'Offer text in English...' },
  offerValidFrom:      { ar: 'تاريخ البداية',                     en: 'Valid From' },
  offerValidUntil:     { ar: 'تاريخ الانتهاء',                    en: 'Valid Until' },
  activeOffer:         { ar: 'نشط',                               en: 'ACTIVE' },
  expiredOffer:        { ar: 'منتهي',                             en: 'EXPIRED' },
  redirectToSalesNo:   { ar: 'لا — اعرض الأسعار',                en: 'No — show pricing' },
  redirectToSalesYes:  { ar: 'نعم — حوّل للفريق',               en: 'Yes — redirect to team' },
  redirectToPricePage:  { ar: 'تحويل لصفحة الأسعار',              en: 'Redirect to pricing page' },
  pricingPageUrl:      { ar: 'رابط صفحة الأسعار',                 en: 'Pricing Page URL' },
  basePackage:         { ar: 'سعر الباقة الأساسية',              en: 'Base Package Price' },
  moduleName:          { ar: 'اسم الموديول',                      en: 'Module name' },
  modulePrice:         { ar: 'السعر',                             en: 'Price' },
  resetPricingConfirm: { ar: 'إعادة تعيين الأسعار للقيم الافتراضية؟', en: 'Reset to default pricing values from gemini.service.js?' },
  techKeywordsAr:      { ar: 'كلمات دلالية تقنية (عربي)',         en: 'Tech Domain Keywords (AR)' },
  techKeywordsEn:      { ar: 'كلمات دلالية تقنية (إنجليزي)',      en: 'Tech Domain Keywords (EN)' },
  salesKeywordsAr:     { ar: 'كلمات المبيعات (عربي)',             en: 'Sales Keywords (AR)' },
  salesKeywordsEn:     { ar: 'كلمات المبيعات (إنجليزي)',          en: 'Sales Keywords (EN)' },
  transferKeywordsAr:  { ar: 'كلمات التحويل (عربي)',              en: 'Transfer Keywords (AR)' },
  transferKeywordsEn:  { ar: 'كلمات التحويل (إنجليزي)',           en: 'Transfer Keywords (EN)' },
  existingCustKw:      { ar: 'كلمات العميل الحالي',               en: 'Existing Customer Keywords' },
  intentTechHintAr:    { ar: 'وصف النية التقنية (عربي)',          en: 'Intent Tech Hint (AR)' },
  intentTechHintEn:    { ar: 'وصف النية التقنية (إنجليزي)',       en: 'Intent Tech Hint (EN)' },
  intentSalesHintAr:   { ar: 'وصف نية المبيعات (عربي)',           en: 'Intent Sales Hint (AR)' },
  intentSalesHintEn:   { ar: 'وصف نية المبيعات (إنجليزي)',        en: 'Intent Sales Hint (EN)' },
  esConfidence:        { ar: 'حد ثقة ES (0-1)',                   en: 'ES Confidence Threshold (0-1)' },
  esMinScore:          { ar: 'الحد الأدنى لنقاط ES',              en: 'ES Min Score' },
  esSuggestion:        { ar: 'حد اقتراحات ES (0-1)',              en: 'ES Suggestion Threshold (0-1)' },
  botPauseTimeout:     { ar: 'مهلة إيقاف البوت (ثانية)',          en: 'Bot Pause Timeout (seconds)' },
  stopWordsExtra:      { ar: 'كلمات إيقاف إضافية للتشابه (JSON)', en: 'Extra Similarity Stop Words (JSON array)' },
  stopWordsRemove:     { ar: 'كلمات إيقاف محذوفة من التشابه (JSON)', en: 'Remove Similarity Stop Words (JSON array)' },
  stopWordsQuery:      { ar: 'كلمات إيقاف إضافية للاستعلام (JSON)',  en: 'Extra Query Stop Words (JSON array)' },
  queryExpNote:        { ar: '🔍 أنماط التوسيع — عند التطابق يفهم البوت السياق من المحادثة السابقة (مثال: "اعدله"، "ده"، "برضو")', en: '🔍 Query Expansion — when matched, bot resolves pronouns from conversation history (e.g. "edit it", "the same")' },
  queryExpPatternsAr:  { ar: 'أنماط التوسيع (عربي) — JSON array of regex strings',    en: 'Query Expansion Patterns (AR) — JSON array of regex strings' },
  queryExpPatternsEn:  { ar: 'أنماط التوسيع (إنجليزي) — JSON array of regex strings', en: 'Query Expansion Patterns (EN) — JSON array of regex strings' },
  botSettingsSaved:    { ar: 'تم حفظ إعدادات البوت!',    en: 'Bot settings saved!' },
  orgCreated:          { ar: 'تم إنشاء المنظمة بنجاح!',  en: 'Organization created successfully!' },
  orgUpdated:          { ar: 'تم تحديث المنظمة!',         en: 'Organization updated!' },
  orgReactivated:      { ar: 'تم إعادة تفعيل المنظمة',   en: 'Organization reactivated' },
  failedCreate:        { ar: 'فشل إنشاء المنظمة',        en: 'Failed to create organization' },
  failedUpdate:        { ar: 'فشل التحديث',               en: 'Failed to update' },
  failedReactivate:    { ar: 'فشل إعادة التفعيل',        en: 'Failed to reactivate' },
  failedSaveBot:       { ar: 'فشل حفظ إعدادات البوت',    en: 'Failed to save bot settings' },
  editTitle:           { ar: 'تعديل: ',                   en: 'Edit: ' },
};

/* ─── style helpers ──────────────────────────────────────── */
const inp = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: '1px solid rgba(255,255,255,0.12)', fontSize: 13,
  boxSizing: 'border-box', background: 'rgba(255,255,255,0.06)',
  color: '#e5e7eb', outline: 'none',
};
const ta  = { ...inp, minHeight: 90, resize: 'vertical', fontFamily: 'inherit' };
const lbl = { display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 5, color: '#9ca3af', letterSpacing: '0.04em', textTransform: 'uppercase' };
const row2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 };
const fldWrap = { marginBottom: 14 };

function Field({ label, children }) {
  return <div style={fldWrap}><label style={lbl}>{label}</label>{children}</div>;
}
function Input({ label, value, onChange, type = 'text', placeholder }) {
  return <Field label={label}><input type={type} value={value || ''} onChange={onChange} placeholder={placeholder || ''} style={inp} /></Field>;
}
function Textarea({ label, value, onChange, placeholder }) {
  return <Field label={label}><textarea value={value || ''} onChange={onChange} placeholder={placeholder || ''} style={ta} /></Field>;
}

/* ─── JSON array editor (success stories / special offers) ── */
function JsonArrayEditor({ label, value, onChange, schema }) {
  const items = (() => { try { return JSON.parse(value) || []; } catch { return []; } })();
  const update = (arr) => onChange(JSON.stringify(arr, null, 2));
  const add    = () => update([...items, Object.fromEntries(schema.map(k => [k, '']))]);
  const remove = (i) => update(items.filter((_, idx) => idx !== i));
  const set    = (i, k, v) => { const a = [...items]; a[i] = { ...a[i], [k]: v }; update(a); };

  return (
    <div style={fldWrap}>
      <label style={lbl}>{label}</label>
      {items.map((item, i) => (
        <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: 12, marginBottom: 10, border: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 12, color: '#9ca3af' }}>#{i + 1}</span>
            <button type="button" onClick={() => remove(i)} style={{ background: 'rgba(239,68,68,0.15)', color: '#f87171', border: 'none', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 11 }}>✕ Remove</button>
          </div>
          {schema.map(key => (
            <div key={key} style={{ marginBottom: 8 }}>
              <label style={{ ...lbl, marginBottom: 3 }}>{key}</label>
              <input value={item[key] || ''} onChange={e => set(i, key, e.target.value)} style={{ ...inp, fontSize: 12 }} />
            </div>
          ))}
        </div>
      ))}
      <button type="button" onClick={add} style={{ padding: '7px 14px', background: 'rgba(99,102,241,0.2)', color: '#a5b4fc', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
        + Add Item
      </button>
    </div>
  );
}

/* ─── Pricing Editor ─────────────────────────────────────── */
const DEFAULT_PRICING = {
  SA: {
    redirect_to_sales: false,
    package: '3,000 ريال/سنة (أو 300 ريال/شهر)',
    modules: [
      { name: 'المقاولات',                  price: '1,500 ريال/سنة' },
      { name: 'إدارة العقارات والأملاك',     price: '1,500 ريال/سنة' },
      { name: 'إدارة العقود',               price: '750 ريال/سنة'   },
      { name: 'الصيانة والجراج',             price: '1,500 ريال/سنة' },
      { name: 'الچيم/الاشتراكات',           price: '1,500 ريال/سنة' },
      { name: 'نقاط البيع POS',             price: '1,000 ريال/سنة' },
      { name: 'التصنيع',                     price: '2,000 ريال/سنة' },
      { name: 'مستخدم إضافي',               price: '200 ريال/سنة'   },
      { name: 'شركة إضافية',                price: '1,250 ريال/سنة' },
    ]
  },
  EG: {
    redirect_to_sales: false,
    package: '36,000 جنيه/سنة (أو 3,600 جنيه/شهر)',
    modules: [
      { name: 'المقاولات',                  price: '20,000 جنيه/سنة' },
      { name: 'إدارة العقارات والأملاك',     price: '20,000 جنيه/سنة' },
      { name: 'إدارة العقود',               price: '10,000 جنيه/سنة' },
      { name: 'الصيانة والجراج',             price: '20,000 جنيه/سنة' },
      { name: 'الچيم/الاشتراكات',           price: '15,000 جنيه/سنة' },
      { name: 'نقاط البيع POS',             price: '10,000 جنيه/سنة' },
      { name: 'التصنيع',                     price: '20,000 جنيه/سنة' },
      { name: 'مستخدم إضافي',               price: '3,000 جنيه/سنة'  },
      { name: 'شركة إضافية',                price: '1,200 جنيه/سنة'  },
    ]
  },
  KW: {
    redirect_to_sales: true,
    package: '',
    modules: []
  },
  OTHER: {
    redirect_to_sales: false,
    package: '$800/year (or $80/month)',
    modules: [
      { name: 'Contracting',                         price: '$400/year'  },
      { name: 'Real Estate & Property Management',   price: '$400/year'  },
      { name: 'Contract Management',                 price: '$200/year'  },
      { name: 'Garage & Maintenance',                price: '$400/year'  },
      { name: 'Gym/Subscriptions',                   price: '$400/year'  },
      { name: 'POS',                                 price: '$300/year'  },
      { name: 'Manufacturing',                       price: '$400/year'  },
      { name: 'Additional User',                     price: '$600/year'  },
      { name: 'Additional Company',                  price: '$300/year'  },
    ]
  }
};

const COUNTRY_LABELS = {
  SA: '🇸🇦 Saudi Arabia',
  EG: '🇪🇬 Egypt',
  KW: '🇰🇼 Kuwait',
  OTHER: '🌍 Other (Default)',
};

function PricingEditor({ value, onChange, lang = 'ar' }) {
  const [activeCountry, setActiveCountry] = useState('SA');

  // parse or use default
  const pricing = (() => {
    try {
      const p = typeof value === 'string' ? JSON.parse(value) : value;
      if (p && typeof p === 'object') {
        // merge with defaults so all countries always exist
        return Object.fromEntries(
          Object.keys(DEFAULT_PRICING).map(cc => [
            cc,
            p[cc] ? { ...DEFAULT_PRICING[cc], ...p[cc] } : { ...DEFAULT_PRICING[cc] }
          ])
        );
      }
    } catch {}
    return JSON.parse(JSON.stringify(DEFAULT_PRICING));
  })();

  const emit = (newPricing) => onChange(JSON.stringify(newPricing, null, 2));

  const setCountryField = (cc, field, val) => {
    const next = { ...pricing, [cc]: { ...pricing[cc], [field]: val } };
    emit(next);
  };

  const setModule = (cc, idx, field, val) => {
    const mods = [...pricing[cc].modules];
    mods[idx] = { ...mods[idx], [field]: val };
    const next = { ...pricing, [cc]: { ...pricing[cc], modules: mods } };
    emit(next);
  };

  const addModule = (cc) => {
    const mods = [...pricing[cc].modules, { name: '', price: '' }];
    emit({ ...pricing, [cc]: { ...pricing[cc], modules: mods } });
  };

  const removeModule = (cc, idx) => {
    const mods = pricing[cc].modules.filter((_, i) => i !== idx);
    emit({ ...pricing, [cc]: { ...pricing[cc], modules: mods } });
  };

  const handleSeedDefaults = () => {
    if (window.confirm(t('resetPricingConfirm', lang))) {
      emit(JSON.parse(JSON.stringify(DEFAULT_PRICING)));
    }
  };

  const cp = pricing[activeCountry] || {};

  return (
    <div>
      {/* Info bar */}
      <div style={{ padding: '10px 14px', background: 'rgba(99,102,241,0.1)', borderRadius: 8, border: '1px solid rgba(99,102,241,0.2)', marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 12, color: '#a5b4fc' }}>💡 Pricing is sent to the AI bot based on customer's country (detected from phone number)</span>
        <button type="button" onClick={handleSeedDefaults} style={{ padding: '4px 12px', background: 'rgba(245,158,11,0.15)', color: '#fbbf24', border: '1px solid rgba(245,158,11,0.3)', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', marginLeft: 12 }}>
          ↺ Reset to Defaults
        </button>
      </div>

      {/* Country tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {Object.keys(DEFAULT_PRICING).map(cc => (
          <button key={cc} type="button" onClick={() => setActiveCountry(cc)} style={{
            padding: '7px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
            background: activeCountry === cc ? 'rgba(99,102,241,0.7)' : 'rgba(255,255,255,0.07)',
            color: activeCountry === cc ? 'white' : '#9ca3af',
          }}>{COUNTRY_LABELS[cc]}</button>
        ))}
      </div>

      {/* Redirect to sales toggle */}
      <div style={{ ...fldWrap, display: 'flex', alignItems: 'center', gap: 12 }}>
        <label style={{ ...lbl, margin: 0 }}>Redirect to Sales Team (no public pricing)</label>
        <select value={cp.pricing_page_url ? '2' : cp.redirect_to_sales ? '1' : '0'} onChange={e => {
          const v = e.target.value;
          if (v === '0') { setCountryField(activeCountry, 'redirect_to_sales', false); setCountryField(activeCountry, 'pricing_page_url', ''); }
          else if (v === '1') { setCountryField(activeCountry, 'redirect_to_sales', true); setCountryField(activeCountry, 'pricing_page_url', ''); }
          else if (v === '2') { setCountryField(activeCountry, 'redirect_to_sales', false); setCountryField(activeCountry, 'pricing_page_url', cp.pricing_page_url || 'https://'); }
        }} style={{ ...inp, width: 'auto', minWidth: 80 }}>
          <option value="0">{t("redirectToSalesNo", lang)}</option>
          <option value="1">{t("redirectToSalesYes", lang)}</option>
          <option value="2">{t("redirectToPricePage", lang)}</option>
        </select>
      </div>

      {!cp.redirect_to_sales && (
        <>
          {/* Package price */}
          <div style={fldWrap}>
            <label style={lbl}>Base Package Price</label>
            <input value={cp.package || ''} onChange={e => setCountryField(activeCountry, 'package', e.target.value)} style={inp} placeholder="e.g. 3,000 ريال/سنة" />
          </div>

          {/* Modules */}
          <div style={fldWrap}>
            <label style={lbl}>Additional Modules</label>
            <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 10, padding: 12, border: '1px solid rgba(255,255,255,0.07)' }}>
              {/* Header */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 8, marginBottom: 8 }}>
                <span style={{ ...lbl, margin: 0 }}>Module Name</span>
                <span style={{ ...lbl, margin: 0 }}>Price</span>
                <span />
              </div>
              {(cp.modules || []).map((mod, idx) => (
                <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                  <input value={mod.name || ''} onChange={e => setModule(activeCountry, idx, 'name', e.target.value)} style={{ ...inp, marginBottom: 0 }} placeholder={t('moduleName', lang)} />
                  <input value={mod.price || ''} onChange={e => setModule(activeCountry, idx, 'price', e.target.value)} style={{ ...inp, marginBottom: 0 }} placeholder={t('modulePrice', lang)} />
                  <button type="button" onClick={() => removeModule(activeCountry, idx)} style={{ background: 'rgba(239,68,68,0.15)', color: '#f87171', border: 'none', borderRadius: 6, padding: '7px 10px', cursor: 'pointer', fontSize: 13 }}>✕</button>
                </div>
              ))}
              <button type="button" onClick={() => addModule(activeCountry)} style={{ padding: '6px 14px', background: 'rgba(99,102,241,0.2)', color: '#a5b4fc', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600, marginTop: 4 }}>
                + Add Module
              </button>
            </div>
          </div>
        </>
      )}

      {cp.redirect_to_sales && !cp.pricing_page_url && (
        <div style={{ padding: '16px', background: 'rgba(245,158,11,0.08)', borderRadius: 8, border: '1px solid rgba(245,158,11,0.2)', marginTop: 8 }}>
          <p style={{ margin: 0, fontSize: 13, color: '#fbbf24' }}>
            ⚠️ The bot will redirect {COUNTRY_LABELS[activeCountry]} customers to the sales team instead of showing prices.
          </p>
        </div>
      )}

      {cp.pricing_page_url !== undefined && cp.pricing_page_url !== '' && cp.pricing_page_url !== null && (
        <div style={{ marginTop: 8 }}>
          <label style={lbl}>{t("pricingPageUrl", lang)}</label>
          <input value={cp.pricing_page_url || ''} onChange={e => setCountryField(activeCountry, 'pricing_page_url', e.target.value)} style={inp} placeholder="https://matixerp.com/pricing" />
          <div style={{ padding: '12px', background: 'rgba(34,197,94,0.08)', borderRadius: 8, border: '1px solid rgba(34,197,94,0.2)', marginTop: 8 }}>
            <p style={{ margin: 0, fontSize: 13, color: '#4ade80' }}>
              🔗 The bot will send this pricing page link to {COUNTRY_LABELS[activeCountry]} customers when they ask about prices.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}


/* ─── Special Offers Editor ─────────────────────────────── */
const COUNTRY_OPTIONS = [
  { code: 'ALL',   label: '🌍 All Countries' },
  { code: 'SA',    label: '🇸🇦 Saudi Arabia'  },
  { code: 'EG',    label: '🇪🇬 Egypt'          },
  { code: 'KW',    label: '🇰🇼 Kuwait'         },
  { code: 'OTHER', label: '🌐 Other'           },
];

function SpecialOffersEditor({ value, onChange, lang = 'ar' }) {
  const items = (() => { try { return JSON.parse(value) || []; } catch { return []; } })();
  const update = (arr) => onChange(JSON.stringify(arr, null, 2));

  const add = () => update([...items, { country: 'ALL', offer_ar: '', offer_en: '', valid_from: '', valid_until: '' }]);
  const remove = (i) => update(items.filter((_, idx) => idx !== i));
  const set = (i, k, v) => { const a = [...items]; a[i] = { ...a[i], [k]: v }; update(a); };

  const isExpired = (dateStr) => {
    if (!dateStr) return false;
    return new Date(dateStr) < new Date();
  };

  return (
    <div style={fldWrap}>
      <label style={lbl}>Special Offers</label>
      {items.length === 0 && (
        <div style={{ padding: '12px 16px', background: 'rgba(255,255,255,0.03)', borderRadius: 8, border: '1px dashed rgba(255,255,255,0.1)', color: '#6b7280', fontSize: 12, marginBottom: 10 }}>
          No special offers. Click t("addOffer", lang) to create one.
        </div>
      )}
      {items.map((item, i) => (
        <div key={i} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: 14, marginBottom: 12, border: `1px solid ${isExpired(item.valid_until) ? 'rgba(239,68,68,0.3)' : 'rgba(99,102,241,0.2)'}` }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: '#9ca3af', fontWeight: 600 }}>Offer #{i + 1}</span>
              {isExpired(item.valid_until) && (
                <span style={{ background: 'rgba(239,68,68,0.15)', color: '#f87171', fontSize: 10, padding: '2px 6px', borderRadius: 4, fontWeight: 700 }}>EXPIRED</span>
              )}
              {item.valid_until && !isExpired(item.valid_until) && (
                <span style={{ background: 'rgba(34,197,94,0.15)', color: '#4ade80', fontSize: 10, padding: '2px 6px', borderRadius: 4, fontWeight: 700 }}>ACTIVE</span>
              )}
            </div>
            <button type="button" onClick={() => remove(i)} style={{ background: 'rgba(239,68,68,0.15)', color: '#f87171', border: 'none', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 11 }}>✕ Remove</button>
          </div>

          {/* Country */}
          <div style={{ marginBottom: 10 }}>
            <label style={{ ...lbl, marginBottom: 4 }}>Target Country</label>
            <select value={item.country || 'ALL'} onChange={e => set(i, 'country', e.target.value)} style={{ ...inp, fontSize: 12 }}>
              {COUNTRY_OPTIONS.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
            </select>
          </div>

          {/* Offer text */}
          <div style={row2}>
            <div>
              <label style={{ ...lbl, marginBottom: 4 }}>Offer Text (AR)</label>
              <textarea value={item.offer_ar || ''} onChange={e => set(i, 'offer_ar', e.target.value)} style={{ ...ta, minHeight: 70, fontSize: 12 }} {...{placeholder: t("offerTextArPh", lang)}} />
            </div>
            <div>
              <label style={{ ...lbl, marginBottom: 4 }}>Offer Text (EN)</label>
              <textarea value={item.offer_en || ''} onChange={e => set(i, 'offer_en', e.target.value)} style={{ ...ta, minHeight: 70, fontSize: 12 }} {...{placeholder: t("offerTextEnPh", lang)}} />
            </div>
          </div>

          {/* Dates */}
          <div style={row2}>
            <div>
              <label style={{ ...lbl, marginBottom: 4 }}>Valid From</label>
              <input type="date" value={item.valid_from || ''} onChange={e => set(i, 'valid_from', e.target.value)} style={{ ...inp, fontSize: 12 }} />
            </div>
            <div>
              <label style={{ ...lbl, marginBottom: 4 }}>Valid Until</label>
              <input type="date" value={item.valid_until || ''} onChange={e => set(i, 'valid_until', e.target.value)} style={{ ...inp, fontSize: 12, borderColor: isExpired(item.valid_until) ? 'rgba(239,68,68,0.5)' : undefined }} />
            </div>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} style={{ padding: '7px 14px', background: 'rgba(99,102,241,0.2)', color: '#a5b4fc', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
        + Add Offer
      </button>
    </div>
  );
}

/* ─── Tab bar ────────────────────────────────────────────── */
function TabBar({ tabs, active, onChange, lang = 'ar' }) {
  return (
    <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: 'rgba(0,0,0,0.2)', padding: 4, borderRadius: 10, flexWrap: 'wrap' }}>
      {tabs.map(t => (
        <button key={t.id} type="button" onClick={() => onChange(t.id)} style={{
          padding: '7px 13px', borderRadius: 7, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
          background: active === t.id ? 'rgba(99,102,241,0.8)' : 'transparent',
          color: active === t.id ? 'white' : '#9ca3af',
          transition: 'all 0.15s',
        }}>{t.label}</button>
      ))}
    </div>
  );
}

/* ─── Main component ─────────────────────────────────────── */
const Organizations = () => {
  /* ── Language ─────────────────────────────── */
    // ── Language sync with sidebar toggle ──────────────────────
  const [lang, setLang] = useState(() => localStorage.getItem('app_language') || 'ar');
  useEffect(() => {
    const sync = () => setLang(localStorage.getItem('app_language') || 'ar');
    window.addEventListener('langChange', sync);
    window.addEventListener('storage', sync);
    const poll = setInterval(sync, 500);
    return () => { window.removeEventListener('langChange', sync); window.removeEventListener('storage', sync); clearInterval(poll); };
  }, []);

  const [organizations, setOrganizations] = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [showCreate,    setShowCreate]    = useState(false);
  const [editOrg,       setEditOrg]       = useState(null);
  const [editTab,       setEditTab]       = useState('org');
  const [botTab,        setBotTab]        = useState('identity');
  const [botConfig,     setBotConfig]     = useState(null);
  const [botLoading,    setBotLoading]    = useState(false);
  const [error,         setError]         = useState('');
  const [success,       setSuccess]       = useState('');
  const [saving,        setSaving]        = useState(false);

  const [form, setForm] = useState({
    name: '', slug: '', plan: 'starter', owner_name: '', owner_email: '', owner_password: '',
    whatsapp_phone_id: '', whatsapp_token: '', ai_model_preference: 'gemini',
    bot_language: 'ar', timezone: 'Asia/Riyadh', trial_days: 14
  });

  const token = localStorage.getItem('token');
  const h = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  const fetchOrgs = async () => {
    try {
      const res  = await fetch('/api/v1/organizations', { headers: h });
      const data = await res.json();
      if (data.success) setOrganizations(data.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchOrgs(); }, []);

  /* load bot config */
  const loadBotConfig = useCallback(async (orgId) => {
    setBotLoading(true);
    try {
      const res  = await fetch(`/api/v1/bot-config/${orgId}`, { headers: h });
      const data = await res.json();
      if (data.success) setBotConfig(data.data);
    } catch (err) { console.error('bot config load error', err); }
    finally { setBotLoading(false); }
  }, [token]);

  const handleTabChange = (tab) => {
    setEditTab(tab);
    if (tab === 'bot' && editOrg) loadBotConfig(editOrg.id);
  };

  const bc = (key, val) => setBotConfig(prev => ({ ...prev, [key]: val }));

  /* Org update */
  const handleUpdate = async (e) => {
    e.preventDefault(); setError(''); setSuccess(''); setSaving(true);
    try {
      const res  = await fetch(`/api/v1/organizations/${editOrg.id}`, { method: 'PUT', headers: h, body: JSON.stringify(editOrg) });
      const data = await res.json();
      if (data.success) { setSuccess(t('orgUpdated', lang)); fetchOrgs(); }
      else setError(data.message);
    } catch { setError(t('failedUpdate', lang)); }
    finally { setSaving(false); }
  };

  /* Bot config save */
  const handleBotSave = async (e) => {
    e.preventDefault(); setError(''); setSuccess(''); setSaving(true);
    try {
      const res  = await fetch(`/api/v1/bot-config/${editOrg.id}`, { method: 'PUT', headers: h, body: JSON.stringify(botConfig) });
      const data = await res.json();
      if (data.success) setSuccess(t('botSettingsSaved', lang));
      else setError(data.message);
    } catch { setError(t('failedSaveBot', lang)); }
    finally { setSaving(false); }
  };

  /* Create org */
  const handleCreate = async (e) => {
    e.preventDefault(); setError(''); setSuccess('');
    try {
      const res  = await fetch('/api/v1/organizations', { method: 'POST', headers: h, body: JSON.stringify(form) });
      const data = await res.json();
      if (data.success) {
        setSuccess(t('orgCreated', lang));
        setShowCreate(false);
        setForm({ name: '', slug: '', plan: 'starter', owner_name: '', owner_email: '', owner_password: '', whatsapp_phone_id: '', whatsapp_token: '', ai_model_preference: 'gemini', bot_language: 'ar', timezone: 'Asia/Riyadh', trial_days: 14 });
        fetchOrgs();
      } else setError(data.message);
    } catch { setError(t('failedCreate', lang)); }
  };

  const handleSuspend = async (id, name) => {
    if (!window.confirm(`Suspend "${name}"? Their agents won't be able to login.`)) return;
    try {
      const res  = await fetch(`/api/v1/organizations/${id}`, { method: 'DELETE', headers: h });
      const data = await res.json();
      if (data.success) { setSuccess('Organization suspended'); fetchOrgs(); }
      else setError(data.message);
    } catch { setError('Failed to suspend'); }
  };

  const handleReactivate = async (id) => {
    try {
      const res  = await fetch(`/api/v1/organizations/${id}`, { method: 'PUT', headers: h, body: JSON.stringify({ status: 'active' }) });
      const data = await res.json();
      if (data.success) { setSuccess(t('orgReactivated', lang)); fetchOrgs(); }
    } catch { setError(t('failedReactivate', lang)); }
  };

  const statusColor = s => ({ active: '#22c55e', trial: '#f59e0b', suspended: '#ef4444', cancelled: '#6b7280' }[s] || '#6b7280');
  const planBadge   = p => ({ free: '#6b7280', starter: '#3b82f6', pro: '#8b5cf6', enterprise: '#f59e0b' }[p] || '#6b7280');

  const closeModal = () => { setEditOrg(null); setEditTab('org'); setBotConfig(null); setBotTab('identity'); };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading organizations...</div>;

  const BOT_TABS = [
    { id: 'identity', label: t('tabIdentity', lang)  },
    { id: 'greeting', label: t('tabGreeting', lang)  },
    { id: 'sales',    label: t('tabSales', lang)     },
    { id: 'pricing',  label: t('tabPricing', lang)  },
    { id: 'intent',   label: t('tabIntent', lang)   },
    { id: 'advanced', label: t('tabAdvanced', lang) },
  ];

  return (
    <Layout>
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>🏢 Organizations</h1>
            <p style={{ margin: '4px 0 0', color: '#9ca3af', fontSize: 14 }}>{organizations.length} organization(s)</p>
          </div>
          <button onClick={() => setShowCreate(!showCreate)} style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
            {showCreate ? '✕ Cancel' : t('newOrg', lang)}
          </button>
        </div>

        {error   && <div style={{ padding: 12, background: 'rgba(220, 38, 38, 0.15)', color: '#fca5a5', borderRadius: 8, marginBottom: 16, border: '1px solid rgba(220, 38, 38, 0.3)' }}>{error}</div>}
        {success && <div style={{ padding: 12, background: 'rgba(22, 163, 74, 0.15)', color: '#86efac', borderRadius: 8, marginBottom: 16, border: '1px solid rgba(22, 163, 74, 0.3)' }}>{success}</div>}

        {/* Create Form */}
        {showCreate && (
          <div style={{ background: 'rgba(255,255,255,0.05)', padding: 24, borderRadius: 12, marginBottom: 24, border: '1px solid rgba(255,255,255,0.1)' }}>
            <h3 style={{ margin: '0 0 16px' }}>Create New Organization</h3>
            <form onSubmit={handleCreate}>
              <div style={row2}>
                {[
                  { key: 'name',              label: t('fieldOrgName', lang), ph: 'e.g. Acme Corp' },
                  { key: 'slug',              label: t('fieldSlug', lang), ph: 'e.g. acme-corp' },
                  { key: 'owner_name',        label: t('fieldOwnerName', lang) },
                  { key: 'owner_email',       label: t('fieldOwnerEmail', lang), type: 'email' },
                  { key: 'owner_password',    label: t('fieldOwnerPassword', lang), type: 'password' },
                  { key: 'whatsapp_phone_id', label: t('fieldWhatsappId', lang), ph: t('optional', lang) },
                ].map(({ key, label, ph, type = 'text' }) => (
                  <div key={key}>
                    <label style={lbl}>{label}</label>
                    <input type={type} value={form[key] || ''} placeholder={ph || ''}
                      onChange={e => setForm({ ...form, [key]: key === 'slug' ? e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') : e.target.value })}
                      required={label.endsWith('*')} style={inp} />
                  </div>
                ))}
                <div>
                  <label style={lbl}>Plan</label>
                  <select value={form.plan} onChange={e => setForm({ ...form, plan: e.target.value })} style={inp}>
                    <option value="free">{t('planFree', lang)}</option><option value="starter">{t('planStarter', lang)}</option>
                    <option value="pro">{t('planPro', lang)}</option><option value="enterprise">{t('planEnterprise', lang)}</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Trial Days</label>
                  <input type="number" value={form.trial_days} onChange={e => setForm({ ...form, trial_days: parseInt(e.target.value) })} style={inp} />
                </div>
              </div>
              <button type="submit" style={{ marginTop: 16, padding: '10px 24px', background: '#22c55e', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                ✅ Create Organization
              </button>
            </form>
          </div>
        )}

        {/* Edit Modal */}
        {editOrg && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}
            onClick={closeModal}>
            <div style={{ background: '#1e1f2e', borderRadius: 16, padding: 28, width: 720, maxHeight: '92vh', overflow: 'auto', border: '1px solid rgba(255,255,255,0.1)' }}
              onClick={e => e.stopPropagation()}>

              {/* Modal header */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ margin: 0, color: '#f3f4f6' }}>✏️ {editOrg.name}</h3>
                <button type="button" onClick={closeModal} style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: 20 }}>✕</button>
              </div>

              {/* Top tabs */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
                {[{ id: 'org', label: t('tabOrg', lang) }, { id: 'whatsapp', label: '📱 WhatsApp' }, { id: 'bot', label: t('tabBot', lang) }].map(t => (
                  <button key={t.id} type="button" onClick={() => handleTabChange(t.id)} style={{
                    padding: '9px 18px', borderRadius: 9, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700,
                    background: editTab === t.id ? '#667eea' : 'rgba(255,255,255,0.07)',
                    color: editTab === t.id ? 'white' : '#9ca3af',
                  }}>{t.label}</button>
                ))}
              </div>

              {/* ══ ORG TAB ══ */}
              {editTab === 'org' && (
                <form onSubmit={handleUpdate}>
                  <div style={row2}>
                    {[
                      { key: 'name',                 label: t('fieldOrgName', lang).replace(' *','') },
                      { key: 'max_agents',            label: 'Max Agents',        type: 'number' },
                      { key: 'max_kb_questions',      label: 'Max KB Questions',  type: 'number' },
                      { key: 'monthly_message_limit', label: t('fieldMonthlyLimit', lang), type: 'number' },
                      { key: 'ai_model_preference',   label: t('fieldAiModel', lang) },
                      { key: 'bot_language',          label: t('fieldBotLang', lang) },
                      { key: 'timezone',              label: t('fieldTimezone', lang) },
                    ].map(({ key, label, type = 'text' }) => (
                      <div key={key}>
                        <label style={lbl}>{label}</label>
                        <input type={type} value={editOrg[key] || ''} onChange={e => setEditOrg({ ...editOrg, [key]: e.target.value })} style={inp} />
                      </div>
                    ))}
                    <div>
                      <label style={lbl}>Plan</label>
                      <select value={editOrg.plan || ''} onChange={e => setEditOrg({ ...editOrg, plan: e.target.value })} style={inp}>
                        <option value="free">{t('planFree', lang)}</option><option value="starter">{t('planStarter', lang)}</option><option value="pro">{t('planPro', lang)}</option><option value="enterprise">{t('planEnterprise', lang)}</option>
                      </select>
                    </div>
                    <div>
                      <label style={lbl}>Status</label>
                      <select value={editOrg.status || ''} onChange={e => setEditOrg({ ...editOrg, status: e.target.value })} style={inp}>
                        <option value="active">{t('statusActive', lang)}</option><option value="trial">{t('statusTrial', lang)}</option><option value="suspended">{t('statusSuspended', lang)}</option><option value="cancelled">{t('statusCancelled', lang)}</option>
                      </select>
                    </div>
                  </div>
                  {/* Generated Links */}
                  {editOrg.slug && (
                    <div style={{ marginTop: 20, padding: 16, background: 'rgba(34,197,94,0.08)', borderRadius: 8, border: '1px solid rgba(34,197,94,0.25)' }}>
                      <div style={{ color: '#4ade80', fontWeight: 600, fontSize: 13, marginBottom: 12 }}>🔗 Generated Links for {editOrg.name}</div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ color: '#9ca3af', minWidth: 120, fontSize: 12 }}>🎫 Helpdesk Portal:</span>
                          <a href={'https://' + editOrg.slug + '-helpdesk.matix.one'} target="_blank" rel="noreferrer"
                            style={{ color: '#34d399', fontFamily: 'monospace', fontSize: 12, textDecoration: 'none', flex: 1 }}>
                            {'https://' + editOrg.slug + '-helpdesk.matix.one'}
                          </a>
                          <button type="button" onClick={() => navigator.clipboard.writeText('https://' + editOrg.slug + '-helpdesk.matix.one')}
                            style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>📋</button>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ color: '#9ca3af', minWidth: 120, fontSize: 12 }}>🤖 KB Bot Admin:</span>
                          <a href={'https://' + editOrg.slug + '-bot.matix.one/login.php'} target="_blank" rel="noreferrer"
                            style={{ color: '#34d399', fontFamily: 'monospace', fontSize: 12, textDecoration: 'none', flex: 1 }}>
                            {'https://' + editOrg.slug + '-bot.matix.one/login.php'}
                          </a>
                          <button type="button" onClick={() => navigator.clipboard.writeText('https://' + editOrg.slug + '-bot.matix.one/login.php')}
                            style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>📋</button>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ color: '#9ca3af', minWidth: 120, fontSize: 12 }}>👨‍💼 Agent Dashboard:</span>
                          <span style={{ color: '#34d399', fontFamily: 'monospace', fontSize: 12, flex: 1 }}>https://agents.matix.one</span>
                          <button type="button" onClick={() => navigator.clipboard.writeText('https://agents.matix.one')}
                            style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>📋</button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                    <button type="submit" disabled={saving} style={{ padding: '9px 22px', background: '#667eea', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                      {saving ? t('saving', lang) : t('save', lang)}
                    </button>
                    <button type="button" onClick={closeModal} style={{ padding: '9px 22px', background: 'rgba(255,255,255,0.07)', color: '#d1d5db', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Cancel</button>
                  </div>
                </form>
              )}

              {/* ══ WHATSAPP TAB ══ */}
              {editTab === 'whatsapp' && (
                <form onSubmit={handleUpdate}>
                  <div style={{ marginBottom: 16, padding: 16, background: 'rgba(102,126,234,0.1)', borderRadius: 8, border: '1px solid rgba(102,126,234,0.3)' }}>
                    <span style={{ fontSize: 13, color: '#a5b4fc', display: 'block', marginBottom: 10 }}>Configure WhatsApp Business API credentials for this organization. These are used to send and receive messages.</span>
                    <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: 8, padding: 12, fontSize: 12 }}>
                      <div style={{ color: '#9ca3af', marginBottom: 6, fontWeight: 600 }}>📋 Meta Webhook Configuration (same for all organizations):</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <span style={{ color: '#9ca3af', minWidth: 100 }}>Callback URL:</span>
                        <code style={{ color: '#34d399', background: 'rgba(52,211,153,0.1)', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace', flex: 1 }}>https://agents.matix.one/webhook/meta</code>
                        <button type="button" onClick={() => {navigator.clipboard.writeText('https://agents.matix.one/webhook/meta');}} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>📋 Copy</button>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ color: '#9ca3af', minWidth: 100 }}>Verify Token:</span>
                        <code style={{ color: '#34d399', background: 'rgba(52,211,153,0.1)', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace', flex: 1 }}>matix_webhook_2026</code>
                        <button type="button" onClick={() => {navigator.clipboard.writeText('matix_webhook_2026');}} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: '2px 8px', borderRadius: 4, fontSize: 11 }}>📋 Copy</button>
                      </div>
                    </div>
                  </div>
                  <div style={row2}>
                    {[
                      { key: 'whatsapp_phone_id', label: 'WhatsApp Phone Number ID', ph: 'e.g. 1082967458222509' },
                      { key: 'whatsapp_notification_phone_id', label: 'Notification Phone ID (optional)', ph: 'For SLA/ticket notifications' },
                      { key: 'whatsapp_business_id', label: 'WhatsApp Business Account ID', ph: 'WABA ID' },
                      { key: 'whatsapp_display_phone', label: 'Display Phone Number', ph: 'e.g. +966 5xx xxx xxx' },
                      { key: 'whatsapp_notification_display_phone', label: 'Notification Display Phone', ph: 'Optional' },
                    ].map(({ key, label, ph }) => (
                      <div key={key}>
                        <label style={lbl}>{label}</label>
                        <input type="text" value={editOrg[key] || ''} placeholder={ph || ''}
                          onChange={e => setEditOrg({ ...editOrg, [key]: e.target.value })} style={inp} />
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 12 }}>
                    <label style={lbl}>WhatsApp Access Token</label>
                    <textarea value={editOrg.whatsapp_token || ''} placeholder="EAAxxxxxx..."
                      onChange={e => setEditOrg({ ...editOrg, whatsapp_token: e.target.value })}
                      style={{ ...inp, minHeight: 80, fontFamily: 'monospace', fontSize: 12 }} />
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                    <button type="submit" disabled={saving} style={{ padding: '9px 22px', background: '#667eea', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                      {saving ? 'Saving...' : '💾 Save WhatsApp Config'}
                    </button>
                    <button type="button" onClick={closeModal} style={{ padding: '9px 22px', background: 'rgba(255,255,255,0.07)', color: '#d1d5db', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Cancel</button>
                  </div>
                </form>
              )}

              {/* ══ BOT SETTINGS TAB ══ */}
              {editTab === 'bot' && (
                botLoading ? (
                  <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Loading bot settings…</div>
                ) : !botConfig ? (
                  <div style={{ textAlign: 'center', padding: 40, color: '#f87171' }}>Failed to load bot config.</div>
                ) : (
                  <form onSubmit={handleBotSave}>
                    <TabBar tabs={BOT_TABS} active={botTab} onChange={setBotTab} lang={lang} />

                    {/* Identity */}
                    {botTab === 'identity' && (
                      <>
                        <div style={row2}>
                          <Input label={t("botNameAr", lang)}     value={botConfig.bot_name}        onChange={e => bc('bot_name', e.target.value)} />
                          <Input label={t("botNameEn", lang)}     value={botConfig.bot_name_en}      onChange={e => bc('bot_name_en', e.target.value)} />
                          <Input label={t("companyNameAr", lang)} value={botConfig.company_name_ar}  onChange={e => bc('company_name_ar', e.target.value)} />
                          <Input label={t("companyNameEn", lang)} value={botConfig.company_name_en}  onChange={e => bc('company_name_en', e.target.value)} />
                          <Input label={t("systemNameAr", lang)}  value={botConfig.system_name}      onChange={e => bc('system_name', e.target.value)} />
                          <Input label={t("systemNameEn", lang)}  value={botConfig.system_name_en}   onChange={e => bc('system_name_en', e.target.value)} />
                        </div>
                        <div>
                          <label style={lbl}>Default Language</label>
                          <select value={botConfig.default_language || 'ar'} onChange={e => bc('default_language', e.target.value)} style={inp}>
                            <option value="ar">{t('langAr', lang)}</option>
                            <option value="en">{t('langEn', lang)}</option>
                            <option value="auto">{t('langAuto', lang)}</option>
                          </select>
                        </div>
                      </>
                    )}

                    {/* Greeting */}
                    {botTab === 'greeting' && (
                      <>
                        <Textarea label={t("greetingAr", lang)} value={botConfig.greeting_message_ar} onChange={e => bc('greeting_message_ar', e.target.value)} />
                        <Textarea label={t("greetingEn", lang)} value={botConfig.greeting_message_en} onChange={e => bc('greeting_message_en', e.target.value)} />
                        <div style={row2}>
                          <Input label={t("btnExistingAr", lang)} value={botConfig.btn_existing_customer_ar} onChange={e => bc('btn_existing_customer_ar', e.target.value)} />
                          <Input label={t("btnExistingEn", lang)} value={botConfig.btn_existing_customer_en} onChange={e => bc('btn_existing_customer_en', e.target.value)} />
                          <Input label={t("btnNewAr", lang)}      value={botConfig.btn_new_customer_ar}      onChange={e => bc('btn_new_customer_ar', e.target.value)} />
                          <Input label={t("btnNewEn", lang)}      value={botConfig.btn_new_customer_en}      onChange={e => bc('btn_new_customer_en', e.target.value)} />
                        </div>
                        <div style={{ padding: '10px 14px', background: 'rgba(99,102,241,0.1)', borderRadius: 8, border: '1px solid rgba(99,102,241,0.2)', margin: '8px 0 12px' }}>
                          <p style={{ margin: 0, fontSize: 12, color: '#a5b4fc' }}>💡 Post-classification greetings (sent after customer clicks a button)</p>
                        </div>
                        <div style={row2}>
                          <Textarea label={t("postExistingAr", lang)} value={botConfig.post_existing_greeting_ar} onChange={e => bc('post_existing_greeting_ar', e.target.value)} />
                          <Textarea label={t("postExistingEn", lang)} value={botConfig.post_existing_greeting_en} onChange={e => bc('post_existing_greeting_en', e.target.value)} />
                          <Textarea label={t("postNewAr", lang)}      value={botConfig.post_new_greeting_ar}      onChange={e => bc('post_new_greeting_ar', e.target.value)} />
                          <Textarea label={t("postNewEn", lang)}      value={botConfig.post_new_greeting_en}      onChange={e => bc('post_new_greeting_en', e.target.value)} />
                        </div>
                      </>
                    )}

                    {/* Sales */}
                    {botTab === 'sales' && (
                      <>
                        <Textarea label={t("salesPersonaAr", lang)} value={botConfig.sales_persona_ar} onChange={e => bc('sales_persona_ar', e.target.value)} placeholder="وصف شخصية البوت في المبيعات..." />
                        <Textarea label={t("salesPersonaEn", lang)} value={botConfig.sales_persona_en} onChange={e => bc('sales_persona_en', e.target.value)} placeholder="Sales bot persona description..." />
                        <Textarea label={t("generalInfoAr", lang)}  value={botConfig.general_info_ar}  onChange={e => bc('general_info_ar', e.target.value)} />
                        <Textarea label={t("generalInfoEn", lang)}  value={botConfig.general_info_en}  onChange={e => bc('general_info_en', e.target.value)} />
                        <JsonArrayEditor
                          label={t("successStories", lang)}
                          value={botConfig.success_stories || '[]'}
                          onChange={v => bc('success_stories', v)}
                          schema={['story_ar', 'story_en']}
                        />
                        <SpecialOffersEditor lang={lang} value={botConfig.special_offers || '[]'}
                          onChange={v => bc('special_offers', v)}
                        />
                      </>
                    )}

                    {/* Pricing */}
                    {botTab === 'pricing' && (
                      <PricingEditor lang={lang} value={botConfig.pricing}
                        onChange={v => bc('pricing', v)}
                      />
                    )}

                    {/* Intent */}
                    {botTab === 'intent' && (
                      <>
                        <div style={{ padding: '10px 14px', background: 'rgba(245,158,11,0.1)', borderRadius: 8, border: '1px solid rgba(245,158,11,0.2)', marginBottom: 16 }}>
                          <p style={{ margin: 0, fontSize: 12, color: '#fbbf24' }}>💡 Keywords are comma-separated. They help the bot classify customer intent correctly.</p>
                        </div>
                        <Textarea label={t("techKeywordsAr", lang)} value={botConfig.tech_domain_keywords_ar} onChange={e => bc('tech_domain_keywords_ar', e.target.value)} />
                        <Textarea label={t("techKeywordsEn", lang)} value={botConfig.tech_domain_keywords_en} onChange={e => bc('tech_domain_keywords_en', e.target.value)} />
                        <Textarea label={t("salesKeywordsAr", lang)}       value={botConfig.sales_keywords_ar}       onChange={e => bc('sales_keywords_ar', e.target.value)} />
                        <Textarea label={t("salesKeywordsEn", lang)}       value={botConfig.sales_keywords_en}       onChange={e => bc('sales_keywords_en', e.target.value)} />
                        <Textarea label={t("existingCustKw", lang)} value={botConfig.existing_customer_keywords} onChange={e => bc('existing_customer_keywords', e.target.value)} />
                        <div style={row2}>
                          <Textarea label={t("transferKeywordsAr", lang)} value={botConfig.transfer_keywords_ar} onChange={e => bc('transfer_keywords_ar', e.target.value)} />
                          <Textarea label={t("transferKeywordsEn", lang)} value={botConfig.transfer_keywords_en} onChange={e => bc('transfer_keywords_en', e.target.value)} />
                        </div>
                      </>
                    )}

                    {/* Advanced */}
                    {botTab === 'advanced' && (
                      <>
                        <div style={{ padding: '10px 14px', background: 'rgba(239,68,68,0.08)', borderRadius: 8, border: '1px solid rgba(239,68,68,0.15)', marginBottom: 16 }}>
                          <p style={{ margin: 0, fontSize: 12, color: '#f87171' }}>⚠️ Changing these values affects bot performance. Only edit if you know what you're doing.</p>
                        </div>
                        <div style={row2}>
                          <Input label={t("esConfidence", lang)} value={botConfig.es_confidence_threshold}  onChange={e => bc('es_confidence_threshold', e.target.value)}  placeholder="0.75" />
                          <Input label={t("esMinScore", lang)}                   value={botConfig.es_min_score}             onChange={e => bc('es_min_score', e.target.value)}             placeholder="5.0"  />
                          <Input label={t("esSuggestion", lang)}  value={botConfig.es_suggestion_threshold}  onChange={e => bc('es_suggestion_threshold', e.target.value)}  placeholder="0.50" />
                          <Input label={t("botPauseTimeout", lang)}    value={botConfig.bot_pause_timeout_seconds} onChange={e => bc('bot_pause_timeout_seconds', e.target.value)} placeholder="300"  />
                        </div>
                        <Textarea label={t("stopWordsExtra", lang)}  value={botConfig.extra_similarity_stop_words}  onChange={e => bc('extra_similarity_stop_words', e.target.value)}  placeholder='["كلمة1","كلمة2"]' />
                        <Textarea label={t("stopWordsRemove", lang)} value={botConfig.remove_similarity_stop_words} onChange={e => bc('remove_similarity_stop_words', e.target.value)} placeholder='["كلمة1"]' />
                        <Textarea label={t("stopWordsQuery", lang)}       value={botConfig.extra_query_stop_words}       onChange={e => bc('extra_query_stop_words', e.target.value)}       placeholder='["كلمة1"]' />

                        <div style={{ padding: '10px 14px', background: 'rgba(99,102,241,0.08)', borderRadius: 8, border: '1px solid rgba(99,102,241,0.15)', margin: '8px 0 12px' }}>
                          <p style={{ margin: 0, fontSize: 12, color: '#a5b4fc' }}>🔍 Query Expansion — الأنماط اللي لما تتطابق مع رسالة العميل، البوت يفهم السياق من المحادثة السابقة قبل ما يدور في الـ KB (مثال: "اعدله"، "ده"، "برضو")</p>
                        </div>
                        <div style={row2}>
                          <Textarea label={t("queryExpPatternsAr", lang)}
                            value={botConfig.query_expansion_patterns_ar}
                            onChange={e => bc('query_expansion_patterns_ar', e.target.value)}
                            placeholder='["اعدله","اعدلها","\\bده\\b","برضو","نفس المشكلة"]'
                          />
                          <Textarea label={t("queryExpPatternsEn", lang)}
                            value={botConfig.query_expansion_patterns_en}
                            onChange={e => bc('query_expansion_patterns_en', e.target.value)}
                            placeholder='["edit it","fix it","the same","what about"]'
                          />
                        </div>

                        <div style={row2}>
                          {[
                            { key: 'has_sales_bot',          label: 'Has Sales Bot'          },
                            { key: 'enable_lead_extraction', label: 'Enable Lead Extraction' },
                            { key: 'enable_booking_module',  label: 'Enable Booking Module'  },
                            { key: 'enable_dialect_switching',label: 'Enable Dialect Switching'},
                          ].map(({ key, label }) => (
                            <div key={key}>
                              <label style={lbl}>{label}</label>
                              <select value={botConfig[key] ? '1' : '0'} onChange={e => bc(key, e.target.value === '1')} style={inp}>
                                <option value="1">Yes</option><option value="0">No</option>
                              </select>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {/* Save / Cancel */}
                    <div style={{ display: 'flex', gap: 8, marginTop: 20, paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                      <button type="submit" disabled={saving} style={{ padding: '9px 22px', background: '#22c55e', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13 }}>
                        {saving ? t('saving', lang) : t('saveBotSettings', lang)}
                      </button>
                      <button type="button" onClick={closeModal} style={{ padding: '9px 22px', background: 'rgba(255,255,255,0.07)', color: '#d1d5db', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Cancel</button>
                    </div>
                  </form>
                )
              )}
            </div>
          </div>
        )}

        {/* Table */}
        <div style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: 'rgba(255,255,255,0.05)' }}>
                {[t('colId', lang),'Organization','Slug','Plan','Status','Agents','Convos','KB','Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#d1d5db', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {organizations.map(org => (
                <tr key={org.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <td style={{ padding: '12px 16px', color: '#9ca3af' }}>{org.id}</td>
                  <td style={{ padding: '12px 16px', fontWeight: 600 }}>{org.name}</td>
                  <td style={{ padding: '12px 16px' }}><code style={{ background: 'rgba(99,102,241,0.15)', padding: '2px 8px', borderRadius: 4, color: '#a5b4fc' }}>{org.slug}</code></td>
                  <td style={{ padding: '12px 16px' }}><span style={{ background: planBadge(org.plan), color: 'white', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{org.plan}</span></td>
                  <td style={{ padding: '12px 16px' }}><span style={{ background: statusColor(org.status) + '20', color: statusColor(org.status), padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{org.status}</span></td>
                  <td style={{ padding: '12px 16px' }}>{org.agent_count}</td>
                  <td style={{ padding: '12px 16px' }}>{org.conversation_count}</td>
                  <td style={{ padding: '12px 16px' }}>{org.kb_count}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => { setEditOrg({ ...org }); setEditTab('org'); setBotConfig(null); setBotTab('identity'); }}
                        style={{ padding: '4px 10px', background: 'rgba(59,130,246,0.15)', color: '#60a5fa', border: '1px solid rgba(59,130,246,0.3)', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>Edit</button>
                      {org.status === 'suspended'
                        ? <button onClick={() => handleReactivate(org.id)} style={{ padding: '4px 10px', background: 'rgba(34,197,94,0.15)', color: '#4ade80', border: '1px solid rgba(34,197,94,0.3)', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>Activate</button>
                        : org.id !== 1 && <button onClick={() => handleSuspend(org.id, org.name)} style={{ padding: '4px 10px', background: 'rgba(239,68,68,0.15)', color: '#f87171', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>Suspend</button>
                      }
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </Layout>
  );
};

export default Organizations;